export const blockIconsHomeNestCamWiredStand = (
	<span className='material-symbols-outlined'>nest_cam_wired_stand</span>
);
